import { render, staticRenderFns } from "./pro-input-add.vue?vue&type=template&id=32e73eac&scoped=true";
import script from "./pro-input-add.vue?vue&type=script&lang=jsx";
export * from "./pro-input-add.vue?vue&type=script&lang=jsx";
import style0 from "./pro-input-add.vue?vue&type=style&index=0&id=32e73eac&prod&lang=less&scoped=true";

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js";
var component = normalizer(script, render, staticRenderFns, false, null, "32e73eac", null);
export default component.exports;